export const commaOrAnd = (i, length) => i < length - 2 ? ", " : i === length - 2 ? " et " : "";
